import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { ModalMainComponent } from 'src/app/modals/modal-main/modal-main.component';
import { MatDialog } from '@angular/material/dialog';
import { FirebaseService } from '../../../service/firebase.service';
import { SharedService } from '../../../services/shared.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ModalTextComponent } from '../../../modals/modal-text/modal-text.component';
import { ConfirmModalComponent } from '../../../modals/confirm-modal/confirm-modal.component';
import { TranslationPipe } from '../../../shared/pipes/translation.pipe';
import { ModalUploadBackgroundComponent } from '../../../modals/modal-upload-background/modal-upload-background.component';
import { EmailContentTutorialComponent } from '../../../modals/email-content-tutorial/email-content-tutorial/email-content-tutorial.component';
@Component({
  selector: 'app-lottery',
  templateUrl: './lottery.component.html',
  styleUrls: ['./lottery.component.scss']
})
export class LotteryComponent implements OnInit, OnChanges {
  startTimeValue: any = "00:00";
  endTimeValue: any = "00:00";
  startDateValue: any = '';
  endDateValue: any = '';
  startTextValue: any = '';
  victoryTextValue: any = '';
  defeatTextValue: any = '';

  prizeArray: any = [];
  maxPrizeNumber: number = 15;

  @Output() configUpdate: EventEmitter<any> = new EventEmitter();
  lastUpdate: any;
  latestUpdateDisplay: any;
  // moduleId: any;

  @Input('lotteryConfig') config: any;
  @Input('moduleId') moduleId: any;
  @Input('fullConfig') fullConfig: any;
  allQuiz: Array<Object> = [];
  selectedQuiz: any = { id: null, data: null };
  //  config: any = {};

  configObserver: Subject<any> = new Subject();



  private dialogRef: any;

  constructor(public dialog: MatDialog, public translation: TranslationPipe, private _firebase: FirebaseService, public _shared: SharedService) {

  }

  ngOnChanges() {

    //console.log("NG CHANGES")

    /* if (this._firebase.user.uid == 'POwF1L6kJvUAH3COeVVF4gRT1kt1') {
      // alert('CHANGE MAAX PRIZER')
       this.maxPrizeNumber = 11;
 
     }*/



    // this._firebase.getModuleFromDevice('lottery', this._shared.selectedDevice.data.group, this._shared.selectedDevice.data.name).then((d) => {
    // this.moduleId = d.id

    //   console.log(d)
    //   console.log(d.id, d.data)
    // if (d.data.config != undefined) {
    // this.config = d.data.config;

    if (this.config.gameActive == undefined)
      this.config.gameActive = true;

    if (this.config.emailConfiguration == undefined) {
      this.config.emailConfiguration = { onlyWin: false, object: "", content: "" }
    }

    if (!this.config.keyboardPosition)
      this.config.keyboardPosition = 'bottom';
    //  console.log(d.data.latestUpdate)

    if (this.fullConfig.latestUpdate) {

      if (!(this.fullConfig.latestUpdate instanceof Date)) {
        this.lastUpdate = this.fullConfig.latestUpdate.toDate()

      }
      else {
        this.lastUpdate = this.fullConfig.latestUpdate;
        this.latestUpdateDisplay = this.fullConfig.latestUpdate.toLocaleString("fr-FR")
      }


    }



    //console.log("lastUpdate", this.lastUpdate)
    //.toLocaleString("fr-FR")// new Date(d.data.latestUpdate).toLocaleDateString("fr-FR")

    //   console.log(this.config)

    if (!(this.config.startDate instanceof Date)) {

      console.log(this.config.startDate, typeof this.config.startDate)
      if (this.config.startDate.nanoseconds || this.config.startDate.seconds)
        this.config.startDate = new Date(this.config.startDate.seconds * 1000 + this.config.startDate.nanoseconds / 1000000)
      else if (typeof this.config.startDate == 'string')
        this.config.startDate = new Date(this.config.startDate)
      else
        this.config.startDate = this.config.startDate.toDate();
    }


    if (!(this.config.endDate instanceof Date)) {

      //console.log(this.config.endDate)
      if (this.config.endDate.nanoseconds || this.config.endDate.seconds) {
        this.config.endDate = new Date(this.config.endDate.seconds * 1000 + this.config.endDate.nanoseconds / 1000000)

      }
      else if (typeof this.config.endDate == 'string')
        this.config.endDate = new Date(this.config.endDate)
      else
        this.config.endDate = this.config.endDate.toDate();
    }



    /* if (!this.config.sound)
       this.config.sound = {
 
         loop: {
           enable: false,
           data: { name: '', url: '' }
         }, win: {
           enable: false,
           data: { name: '', url: '' }
         }, lose: {
           enable: false,
           data: { name: '', url: '' }
         }
       }*/

    //  }

    /*else {
      /* Default config if not found 
      this.config = {
        Nbr_total_lot: 0,
        current_Nbr_total_lot: 0,
        endDate: new Date(),
        endTime: "23:00",
        startDate: new Date(),
        startTime: "08:00",
        latestGame: new Date(),
        startText: "Lancez la roue !",
        sound: {
          loop: {
            enable: false,
            data: { name: '', url: '' }
          }, win: {
            enable: false,
            data: { name: '', url: '' }
          }, lose: {
            enable: false,
            data: { name: '', url: '' }
          },

        },
        prizeArray: [
          {
            descriptif: 'Perdu',
            isWinner: false,
            nbr: 0,
            resultText: "Vous avez perdu",
            currentQuantity: 0,
            color: "#FFFFFF"
          }
        ]

      }
    }*/

    //console.log('THIS PRIZE ARRAY', this.config.prizeArray)
    this.prizeArray = this.config.prizeArray


    console.log("PRIZE ARRAY", this.prizeArray, this.prizeArray[0])
    //   })


    if (this._shared.selectedDevice.data.modules.media)
      this._firebase.getAllQuizFromDevice(this._shared.selectedDevice.data.group, this._shared.selectedDevice.data.name).then(d => {
        //console.log(d)

        //console.log(d.find(v => v.id == this.config.selectedQuiz))
        if (this.config.selectedQuiz) {


          this.selectedQuiz = d.find(v => v.id == this.config.selectedQuiz)
          if (this.selectedQuiz == undefined)
            this.selectedQuiz = { id: null, data: null }
          console.log(this.config.selectedQuiz, this.selectedQuiz)
        }
        else {
          this.selectedQuiz = null;
        }



        //console.log()
        this.allQuiz = d;

      })


  }

  ngOnInit() {
    // this.configObserver = new Subject<any>(this.config);
    this.configObserver.subscribe(d => {
      if (Object.keys(d).length > 0) {
        console.log(this.lastUpdate)
        this.configUpdate.emit({ currentConfig: this.config, currentLatestUpdate: this.lastUpdate });

        //        console.log(this.lastUpdate)
        /* this._firebase.updateConfigModule({ config: this.config, latestUpdate: this.lastUpdate }, this.moduleId).then(d => {
           this.lastUpdate = d;
         })*/

        //       this._firebase.updateModule(this.moduleId, { config: this.config, latestUpdate: new Date() })
      }


    })


  }

  /**
   * Apply the config to all modules of the group
   * @param config The new module config
   */
  applyToAllGroup(config) {



    this.dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '30vw',
      height: '30vh',
      data: { title: this.translation.transform('confirmOperation'), ok: 'OK', cancel: this.translation.transform('cancel') }
    })


    this.dialogRef.afterClosed().subscribe((result) => {

      if (result) {
        this._firebase.updateModuleOfAllGroup('lottery', this._shared.selectedDevice.data.group, this._shared.selectedDevice.data.name, config)
      }

      else {

      }

    })
  }

  openTutoEmailContent() {
    this.dialogRef = this.dialog.open(EmailContentTutorialComponent, {
      width: "95vw",
      height: "95vh",

    });
  }

  /**
   * Trigger observer to update config
   * */
  changeValue() {
    //console.log(this.selectedQuiz)

    console.log("CHANGE VALUE")

    if (this.selectedQuiz)
      this.config.selectedQuiz = this.selectedQuiz.id;


    if (this.config.startDate > this.config.endDate)
      this.config.endDate = this.config.startDate





    this.configObserver.next(this.config);





  }

  /**
   * Update the prize
   * @param item The prize element
   * @param index The prize's index
   */
  updatePrize(item, index) {


    let update = () => {

      if (item.special == undefined)
        item.special = false;



      if (!item.isWinner)
        item.nbr = 0;
      var _data = {
        type: 'lottery',
        title: this.translation.transform('changePrize'),
        name: item.descriptif,
        quantity: item.nbr,
        winningText: item.resultText,
        winner: item.isWinner,
        special: item.special,
        color: item.color,
        buttonLabel: 'Valider',
        buttonColor: 'accent',
        index: index,
        gameType: this.config.gameType,
        imgData: item.imgData,
        endImgData: item.endImgData,
        endSound: item.endSound
      };

      this.dialogRef = this.dialog.open(ModalMainComponent, {

        height: '90vh',
        data: _data
      })

      this.dialogRef.afterClosed().subscribe(result => {
        //console.log(result)
        // console.log(index)
        //   console.log("RESULT:", result)


        console.log(result)
        if (result) {

          this.prizeArray[index] = {
            descriptif: result.name, nbr: result.quantity, resultText: result.winningText, isWinner: result.winner, color: result.color, special: result.special
          }

          if (result.endImgData)
            this.prizeArray[index].endImgData = result.endImgData

          if (result.endSound) {
            this.prizeArray[index].endSound = result.endSound
          }

          if (result.imgData)
            this.prizeArray[index].imgData = result.imgData
          //console.log(result.imgData)

          let uploadFilePromise = [];


          console.log(result);

          if (result.endSoundFile) {
            uploadFilePromise.push(this._firebase.uploadFiles([result.endSoundFile], 'slot').then(d => {
              this.prizeArray[index].endSound = { name: d[0].data.name, url: d[0].url }
            }).catch(err => {
              console.log(err)
            }))
          }

          

          if (result.endFile) {
            uploadFilePromise.push(this._firebase.uploadFiles([result.endFile], 'slot').then(d => {
              console.log(d, d[0].defaultName)
              this.prizeArray[index].endImgData = { name: d[0].data.name, url: d[0].url, defaultName: d[0].defaultName || "" }
            }).catch(err => {
              console.log(err)
            }))
          }
          if (result.eventFile) {

            uploadFilePromise.push(this._firebase.uploadFiles([result.eventFile], 'slot').then(d => {
              this.prizeArray[index].imgData = { name: d[0].data.name, url: d[0].url }
            }).catch(err => {
              console.log(err)
            }))
          }

          if (!result.endFile && !result.EventFile) {

            let Nbr_total_lot = 0;
            let current_Nbr_total_lot = 0;

            this.prizeArray.forEach((item) => {
              Nbr_total_lot += item.nbr;
              item.currentQuantity = item.nbr;

              current_Nbr_total_lot += item.nbr;
            })


            //console.log(this.prizeArray)
            this.config.prizeArray = this.prizeArray;
            this.config.Nbr_total_lot = Nbr_total_lot;
            this.config.current_Nbr_total_lot = current_Nbr_total_lot
            this.configObserver.next(this.config);
          }

          Promise.all(uploadFilePromise).then(d => {
            //console.log("PROMISE UPLOAD FILE")
            //    this.prizeArray[index].imgData = { name: d[0].data.name, url: d[0].url }

            let Nbr_total_lot = 0;
            let current_Nbr_total_lot = 0;

            this.prizeArray.forEach((item) => {
              Nbr_total_lot += item.nbr;
              item.currentQuantity = item.nbr;

              current_Nbr_total_lot += item.nbr;
            })
            this.config.prizeArray = this.prizeArray;
            this.config.Nbr_total_lot = Nbr_total_lot;
            this.config.current_Nbr_total_lot = current_Nbr_total_lot
            this.configObserver.next(this.config);
          })


        }
      });
    }


    //console.log(new Date(), this.config.startDate, this.config.endDate, this.config.startTime, this.config.endTime)

    let currentDate = new Date();

    if (this.config.startDate <= currentDate && currentDate <= this.config.endDate) {
      this.dialogRef = this.dialog.open(ModalTextComponent, {
        width: '30vw',
        height: '30vh',
        data: this.translation.transform('warningGameUpdate')
      })

      this.dialogRef.afterClosed().subscribe(result => {
        update();
      })
    }

    else
      update();



  }


  /**
   * Open modal to add new prize && update module config
   * */
  addPrize() {


    var _data = {
      type: 'lottery',
      title: this.translation.transform('addPrize'),
      buttonLabel: this.translation.transform('validate'),
      buttonColor: 'accent',
      gametype: this.config.gameType
    };



    if (this.prizeArray.length < this.maxPrizeNumber) {
      this.dialogRef = this.dialog.open(ModalMainComponent, {

        height: '50vh',
        data: _data
      })

      this.dialogRef.afterClosed().subscribe(result => {


        if (result) {
          if (!this.checkIfAlreadyExistInPrize(result.name, result.quantity)) {


            if (result.winner == undefined)
              result.winner = false;
            this.prizeArray.push({ descriptif: result.name || "Lot", nbr: result.quantity || 0, resultText: result.winningText || "", isWinner: result.winner || false, color: result.color || "#FFFFFF" })
          }


        }


        let Nbr_total_lot = 0;
        let current_Nbr_total_lot = 0;

        this.prizeArray.forEach((item) => {
          Nbr_total_lot += item.nbr;
          item.currentQuantity = item.nbr;

          current_Nbr_total_lot += item.nbr;
        })


        this.config.prizeArray = this.prizeArray;
        this.config.Nbr_total_lot = Nbr_total_lot;
        this.config.current_Nbr_total_lot = current_Nbr_total_lot
        this.configObserver.next(this.config);
      });
    }

    else {
      alert(this.translation.transform('warningTooManyPrize'))
    }


  }

  removeSound(type) {

    this.dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '30vw',
      height: '30vh',
      data: { title: this.translation.transform('confirmOperation'), ok: 'OK', cancel: this.translation.transform('cancel') }
    })


    this.dialogRef.afterClosed().subscribe((result) => {

      if (result) {
        this._firebase.removeFileFromUrl(this.config.sound[type].data.url).then(d => {
          this.config.sound[type].data.name = "";
          this.config.sound[type].data.url = "";

          this.changeValue();
        })
      }

      else {

      }

    })



  }

  uploadSound(e, type: string) {


    if (this.config.sound[type].data.name.length > 0) {

      this._firebase.removeFileFromUrl(this.config.sound[type].data.url).then(d => {
        this.config.sound[type].data.name = d[0].data.name;
        this.config.sound[type].data.url = d[0].url;

        this.changeValue();
      })
    }
    else {
      this._firebase.uploadFiles(e.target.files, 'sound').then(d => {
        this.config.sound[type].data.name = d[0].data.name;
        this.config.sound[type].data.url = d[0].url;

        this.changeValue();
      })
    }




    //console.log(e, type)
  }



  uploadElement(name: string = null) {
    this.dialogRef = this.dialog.open(ModalUploadBackgroundComponent, {
      width: '300px',
      height: '300px',
      data:
      {
        title: this.translation.transform('importMedia')
      }
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this._shared.uploadEvent = result;
        this._shared.uploadFolder = 'media';


        this._firebase.uploadFiles(result.target.files, 'media').then(d => {
          //console.log(d)

          if (name == null)
            this.config.endBackground = { name: d[0].data.name, url: d[0].url }
          else if (name == 'wheelBackground')
            this.config.wheelBackground = { name: d[0].data.name, url: d[0].url, defaultName: d[0].defaultName }

          this.changeValue();
        })
      }
    })
  }

  deleteLotteryBackgroundElement(e) {
    this.dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '70vw',
      height: '30vh',
      maxWidth: '500px',
      data: {
        title: this.translation.transform('warningDeleteMedia'),
        type: 'mediaBackground'
      }
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this._firebase.removeImg(e.url)
        e.url = null;
        e.name = null;

        if (e.defaultName)
          e.defaultName = null;
        this.changeValue();
      }
    });
  }

  showColorModal(val, type) {




    let _data = {
      type: 'color',
      title: this.translation.transform('colorTextDisplay'),
      currentValue: val,
      buttonLabel: this.translation.transform('validate'),
      buttonColor: 'accent'
    }



    this.dialogRef = this.dialog.open(ModalMainComponent, {

      height: '350px',
      data: _data
    })


    this.dialogRef.afterClosed().subscribe(result => {

      if (result) {
        if (type == 'text') {
          this.config.colorText = result.currentValue
        }
        else if (type == 'background') {
          this.config.colorBackground = result.currentValue;
        }
        else if (type == 'button') {
          this.config.colorButton = result.currentValue;
        }
        this.changeValue();
      }
    });
  }

  /**
   * Check if the prize already exit
   * @param name The prize's name
   * @param quantity The prize's quantiy
   */
  checkIfAlreadyExistInPrize(name, quantity) {
    let exist = false;


    this.prizeArray.forEach((item) => {
      if (item.name == name && item.quantity == quantity)
        exist = true;
    })


    return exist;
  }


  /**
   * Remove prize from the array
   * @param index The prize's index
   */
  removeFromPrizeArray(index) {


    //  console.log(index)
    this.prizeArray.splice(index, 1)


    this.config.prizeArray = this.prizeArray;
    let Nbr_total_lot = 0;
    this.prizeArray.forEach((item) => {
      Nbr_total_lot += item.nbr;
    })
    this.config.Nbr_total_lot = Nbr_total_lot;
    this.configObserver.next(this.config)
  }

  /**
   * Open corresponding modal 
   * @param s The modal's type
   * @param value The modal's data value
   */
  showModal(s: string, value: string) {


    var _data = {};

    switch (s) {
      case 'startTextValue':
        _data = {
          type: 'text',
          title: this.translation.transform('changeStartText'),
          currentValue: this.config.startText,
          buttonLabel: this.translation.transform('change'),
          buttonColor: 'warn'
        }
        break;

      case 'victoryTextValue':
        _data = {
          type: 'text',
          title: this.translation.transform('changewinningText'),
          currentValue: this.config.victoryText,
          buttonLabel: this.translation.transform('validate'),
          buttonColor: 'accent'
        }
        break;
      case 'defeatTextValue':
        _data = {
          type: 'text',
          title: this.translation.transform('changeloosingText'),
          currentValue: this.config.defeatText,
          buttonLabel: this.translation.transform('validate'),
          buttonColor: 'accent'
        }
        break;
      default:
        break;

    }

    this.dialogRef = this.dialog.open(ModalMainComponent, {
      height: '350px',
      data: _data
    })

    this.dialogRef.afterClosed().subscribe(result => {

      // let tmpConfig 

      if (result) {
        switch (s) {
          case 'startTextValue':
            this.config.startText = result.currentValue
            break;
          case 'victoryTextValue':
            this.config.victoryText = result.currentValue
            break;
          case 'defeatTextValue':
            this.config.defeatText = result.currentValue
            break;
          default:
            break;
        }
        this.configObserver.next(this.config);
      }
    });
  }
}
